module.exports = __webpack_public_path__ + "static/media/MicrosoftTeams-image.9195559e.png";